import { Skeleton } from "antd";

export const shimmerColumns = [
  {
    key: "display_as",
    title: (
      <Skeleton
        paragraph={false}
        title={{ style: { margin: "auto" } }}
        loading
        active
      />
    ),
    dataIndex: "display_as",
    className: "td-mobile history-order-item",
    width: "100%",
    render: () => (
      <Skeleton
        paragraph={false}
        title={{ style: { margin: "auto" } }}
        loading
        active
      />
    ),
  },
];

export const shimmerTableData = [...new Array(10)].map((_) => ({
  display_as: "",
}));
